import React, { Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import Utils from "../../utils/utils";
import ImageInput from "../../widgets/ImageInput";
import ImageSilentInput from "../../widgets/ImageSilentInput";
import editEvento from "../../services/editEvento";
import sendEvento from "../../services/sendEvento";
import sendEventEmail from "../../services/sendEventEmail";
import MyDatePicker from "../../widgets/DatePicker";
import moment from "moment";
import getEvento from "../../services/getEvento";
import Table from "../../widgets/tables/Table";
import TimeInput from "../../widgets/TimeInput";
import Modal from "../../widgets/Modal";
import getCategorieCorsi from "../../services/getCategorieCorsi";
import getCorsi from "../../services/getCorsi";
import getStudentiInvitati from "../../services/getStudentiInvitati";
import sendReminder from "../../services/sendReminder";
// Editor WYSIWYG per formattazione HTML
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "../../widgets/css/editor.css";

export default class EditEvento extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      titolo: "",
      link1: "",
      link2: "",
      titolo_l1: "",
      titolo_l2: "",
      desc: "",
      attachment: "",
      attachmentFileName: "",
      locandina: "",
      orario: "",
      orarioFine: "",
      isMobile: window.innerWidth < 768,
      partecipanti: 0,
      inviato_s: true,
      inviato_i: true,
      selectedCategoria: [],
      optionsCategoria: [],
      optionsCorsi: [],
      selectedCorsi: [],
      listaPartecipanti: [],
      listaInvitati: [],
      listaAttesa: [],
      listaRitirati: [],
      selectedCategoriaExStudenti: null,
      blacklist: false,
      editorState: EditorState.createEmpty(),
      isEmailModalOpen: false,
      selectedCategoriaEmail: [],
      selectedCorsiEmail: [],
      selectedCategoriaExStudentiEmail: null,
      blacklistEmail: false,
      uploadProgress: 0,
      isUploading: false,
    };

    this.startDateRef = React.createRef();

    this.handleBlackListChange = this.handleBlackListChange.bind(this);
  }

  async reload() {
    this.setState({ isLoading: true });

    const cookies = new Cookies();
    let username = cookies.get("username", { path: "/" });
    let token = cookies.get("token", { path: "/" });
    let current = cookies.get("currentEvent", { path: "/" });

    this.categorieCorsi = await getCategorieCorsi(username, token);
    this.corsi = await getCorsi(username, token);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (!current) {
      window.location.href = "/app/eventi";
      return;
    }

    let evento = await getEvento(username, token, current);

    let studentiInvitati = await getStudentiInvitati(username, token, current);

    const listaPartecipanti = studentiInvitati.filter(
      (studente) => studente.partecipa === 1
    );

    const listaInvitati = studentiInvitati.filter(
      (studente) => studente.partecipa === 0 && studente.lista_attesa === 0
    );

    const listaAttesa = studentiInvitati.filter(
      (studente) => studente.lista_attesa === 1
    );

    const listaRitirati = studentiInvitati.filter(
      (studente) => studente.partecipa === -1
    );

    const optionsCategoria = this.categorieCorsi.map((categoria) => ({
      value: categoria.id,
      label: categoria.name,
    }));

    const corsiFormat = this.corsi
      .filter((corso) => {
        const dateEnd = new Date(corso.dateEnd);
        const dateEndFormatted = dateEnd.toISOString().split("T")[0];

        return dateEndFormatted > today.toISOString().split("T")[0];
      })
      .map((corso) => ({
        value: corso.id,
        label: corso.name,
      }));

    // Gestione nome file allegato
    // Nota: l'allegato non viene più caricato da getEvento per motivi di performance
    // (può essere molto pesante - fino a 80MB). Viene indicato solo se esiste.
    let attachmentFileName = "";
    if (evento.has_allegato === "true" || evento.has_allegato === true) {
      // Mostra il nome originale del file se disponibile
      if (evento.allegato_nome) {
        attachmentFileName = evento.allegato_nome;
      } else {
        attachmentFileName = "File allegato esistente";
      }
    }

    this.setState({
      titolo: evento.titolo,
      desc: evento.descrizione,
      link1: evento.link_1,
      link2: evento.link_2,
      titolo_l1: evento.titolo_link_1,
      titolo_l2: evento.titolo_link_2,
      attachment: "", // Non carichiamo l'allegato esistente per motivi di performance
      attachmentFileName: attachmentFileName,
      locandina: evento.locandina,
      inviato_s: evento.inviato_studenti === "1",
      inviato_i: evento.inviato_insegnanti === "1",
      data: evento.data
        ? moment(evento.data, "DD/MM/yyyy").toDate()
        : undefined,
      listaInvitati,
      listaAttesa,
      listaPartecipanti,
      listaRitirati,
      partecipanti: evento.n_partecipanti,
      orario: evento.orario,
      orarioFine: evento.orario_fine,
      isModalOpen: false,
      optionsCategoria: [
        { label: "SELEZIONA TUTTI", value: "seleziona tutti" },
        ...optionsCategoria,
      ],
      optionsCorsi: [...corsiFormat],
      exStudentiCategoria: [
        { label: "SELEZIONA TUTTI", value: "seleziona tutti" },
        ...optionsCategoria,
      ],
      editorState: evento.descrizione
        ? this.convertHtmlToEditorState(evento.descrizione)
        : EditorState.createEmpty(),
    });

    this.closeModal = this.closeModal.bind(this);
    this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
    this.handleCorsoChange = this.handleCorsoChange.bind(this);
    this.handleCategoriaChangeExStudenti = this.handleCategoriaChangeExStudenti.bind(
      this
    );
    this.closeEmailModal = this.closeEmailModal.bind(this);
    this.handleCategoriaChangeEmail = this.handleCategoriaChangeEmail.bind(
      this
    );
    this.handleCorsoChangeEmail = this.handleCorsoChangeEmail.bind(this);
    this.handleCategoriaChangeExStudentiEmail = this.handleCategoriaChangeExStudentiEmail.bind(
      this
    );
    this.handleBlackListChangeEmail = this.handleBlackListChangeEmail.bind(
      this
    );

    this.setState({ isLoading: false });
  }

  async componentDidMount() {
    window.addEventListener("resize", () => this.manageResize());
    await this.reload();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", () => this.manageResize());
  }

  manageResize() {
    if (window.innerWidth >= 768) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }
  }

  handleCategoriaChange(option) {
    this.setState({ selectedCategoria: option, selectedCorsi: null });
  }

  handleCorsoChange(option) {
    this.setState({ selectedCorsi: option });
  }

  handleBlackListChange() {
    this.setState((prevState) => ({ blacklist: !prevState.blacklist }));
  }

  handleCategoriaChangeExStudenti(option) {
    this.setState({ selectedCategoriaExStudenti: option });
  }

  lockedSaveEvento = Utils.disallowConcurrency(this.save.bind(this));

  openModal() {
    this.setState({ isModalOpen: true });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  openEmailModal() {
    this.setState({ isEmailModalOpen: true });
  }

  closeEmailModal() {
    this.setState({ isEmailModalOpen: false });
  }

  handleCategoriaChangeEmail(option) {
    this.setState({ selectedCategoriaEmail: option, selectedCorsiEmail: null });
  }

  handleCorsoChangeEmail(option) {
    this.setState({ selectedCorsiEmail: option });
  }

  handleCategoriaChangeExStudentiEmail(option) {
    this.setState({ selectedCategoriaExStudentiEmail: option });
  }

  handleBlackListChangeEmail() {
    this.setState((prevState) => ({
      blacklistEmail: !prevState.blacklistEmail,
    }));
  }

  render() {
    var headCells = [
      { id: "nome", numeric: false, disablePadding: true, label: "Nome" },
      { id: "cognome", numeric: true, disablePadding: false, label: "Cognome" },
      { id: "mail", numeric: true, disablePadding: false, label: "Mail" },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["nome", "cognome", "mail"];

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          {/* Progress bar overlay per upload */}
          {this.state.isUploading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  width: "80%",
                  maxWidth: "500px",
                  backgroundColor: "white",
                  padding: "30px",
                  borderRadius: "10px",
                  textAlign: "center",
                }}
              >
                <h3 style={{ marginBottom: "20px" }}>
                  {this.state.uploadProgress < 95
                    ? "📤 Caricamento file..."
                    : this.state.uploadProgress < 100
                    ? "⏳ Elaborazione..."
                    : "✅ Completato!"}
                </h3>
                <div
                  style={{
                    width: "100%",
                    height: "30px",
                    backgroundColor: "#f0f0f0",
                    borderRadius: "15px",
                    overflow: "hidden",
                    marginBottom: "15px",
                  }}
                >
                  <div
                    style={{
                      width: `${this.state.uploadProgress}%`,
                      height: "100%",
                      backgroundColor:
                        this.state.uploadProgress === 100
                          ? "#4caf50"
                          : "#2196f3",
                      transition: "width 0.3s ease-in-out",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    {this.state.uploadProgress}%
                  </div>
                </div>
                <p style={{ margin: 0, color: "#666" }}>
                  Attendere il completamento dell'operazione
                </p>
              </div>
            </div>
          )}

          <PageTitle title={this.state.titolo} />

          <div
            style={{
              display: "flex",
              flexDirection: this.state.isMobile ? "column" : "row",
            }}
          >
            <div style={{ flex: 1, padding: "0 10px" }}>
              <h3 style={{ marginTop: 20 }}>Informazioni generali</h3>
              <p style={{ opacity: 0.5, marginBottom: 10, marginTop: -20 }}>
                Modifica titolo e descrizione dell'evento.
                <br />
                Se desideri, cambia l'immagine di copertina
                <br />
                (possibilmente orizzontale).
              </p>

              {!this.state.isLoading && (
                <ImageInput
                  name="Copertina"
                  value={this.state.locandina}
                  onChange={(base64) => {
                    this.setState({ locandina: base64 });
                  }}
                />
              )}

              <TextInput
                name={"Titolo"}
                value={this.state.titolo}
                onChange={(text) => {
                  this.setState({ titolo: text });
                }}
              />

              <MyDatePicker
                ref={this.startDateRef}
                name={"Data"}
                value={this.state.data ? this.state.data : null}
              />

              <TimeInput
                autoFocus
                readOnly={false}
                time
                name={"Orario inizio"}
                value={this.state.orario}
                onChange={(val) => this.setState({ orario: val })}
              />

              <TimeInput
                autoFocus
                readOnly={false}
                time
                name={"Orario fine"}
                value={this.state.orarioFine}
                onChange={(val) => this.setState({ orarioFine: val })}
              />

              <TextInput
                name="Numero partecipanti"
                type="number"
                value={this.state.partecipanti}
                onChange={(num) => {
                  this.setState({ partecipanti: num });
                }}
              />

              <div style={{ marginTop: 20 }}>
                <label style={{ marginBottom: 10, display: "block" }}>
                  Descrizione dell'evento
                </label>
                <Editor
                  editorState={this.state.editorState}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  onEditorStateChange={(editorState) => {
                    this.setState({
                      editorState,
                      desc: draftToHtml(
                        convertToRaw(editorState.getCurrentContent())
                      ),
                    });
                  }}
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "fontSize",
                      "list",
                      "textAlign",
                      "colorPicker",
                      "link",
                      "emoji",
                      "history",
                    ],
                    inline: {
                      options: [
                        "bold",
                        "italic",
                        "underline",
                        "strikethrough",
                        "monospace",
                      ],
                    },
                  }}
                  localization={{
                    locale: "it",
                  }}
                />
              </div>
            </div>

            <div style={{ flex: 1, padding: "0 10px" }}>
              <h3 style={{ marginTop: 20 }}>Allegato</h3>
              <p style={{ opacity: 0.5, marginBottom: 10, marginTop: -20 }}>
                Aggiungi un allegato che potrà essere scaricato dagli studenti.
              </p>

              {this.state.attachment && !this.state.attachmentFileName && (
                <div
                  style={{
                    marginBottom: "15px",
                    padding: "10px",
                    backgroundColor: "#e3f2fd",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ fontSize: "14px", color: "#1976d2" }}>
                    📎 Documento già caricato
                  </span>
                  <a
                    href={this.state.attachment}
                    download="documento.pdf"
                    style={{
                      padding: "5px 15px",
                      backgroundColor: "#1976d2",
                      color: "white",
                      borderRadius: "4px",
                      textDecoration: "none",
                      fontSize: "12px",
                    }}
                  >
                    Scarica
                  </a>
                </div>
              )}

              <ImageSilentInput
                name={
                  this.state.attachmentFileName
                    ? this.state.attachmentFileName
                    : "Seleziona nuovo documento (opzionale)"
                }
                fileName={this.state.attachmentFileName}
                key={Math.random()}
                value={this.state.attachment}
                onChange={async (base64, fileName, fileInfo) => {
                  // fileName è ora passato direttamente come secondo parametro
                  this.setState({
                    attachment: base64,
                    attachmentFileName: fileName || "",
                  });
                }}
              />

              <h3 style={{ marginTop: 20 }}>Links</h3>
              <p style={{ opacity: 0.5, marginBottom: 10, marginTop: -20 }}>
                Inserisci fino a 2 link per questo evento.
                <br />I campi 'titolo' saranno utilizzati come testo per i
                pulsanti sull'app mobile.
              </p>

              <TextInput
                name={"Link 1"}
                value={this.state.link1}
                onChange={(text) => {
                  this.setState({ link1: text });
                }}
              />

              <TextInput
                name={"Titolo link 1"}
                value={this.state.titolo_l1}
                onChange={(text) => {
                  this.setState({ titolo_l1: text });
                }}
              />

              <TextInput
                name={"Link 2"}
                value={this.state.link2}
                onChange={(text) => {
                  this.setState({ link2: text });
                }}
              />

              <TextInput
                name={"Titolo link 2"}
                value={this.state.titolo_l2}
                onChange={(text) => {
                  this.setState({ titolo_l2: text });
                }}
              />
            </div>
          </div>

          <h3 style={{ marginTop: 20, fontSize: 28 }}>Lista Partecipanti</h3>

          <Table
            headCells={headCells}
            searchCols={this.searchCols}
            assenze={false}
            calendar={false}
            onChangeCategoria={this.handleCategoriaChange}
            onChangeCorsi={this.handleCorsiChange}
            pdf={false}
            excel={false}
            mail={true}
            phone={false}
            rows={this.state.listaPartecipanti}
            // 	onDelete={async id => {
            // 		if (window.confirm("Sei sicuro di voler eliminare lo studente?") == false) return;

            // 		const cookies = new Cookies();
            // 		const username = cookies.get("username", { path: "/" });
            // 		const token = cookies.get("token", { path: "/" });
            // 		await DeleteStudente(username, token, id);
            // 		this.reload();
            // 	}}
          />

          <br />

          <h3 style={{ marginTop: 20, fontSize: 28 }}>Lista Attesa</h3>

          <Table
            headCells={headCells}
            searchCols={this.searchCols}
            assenze={false}
            calendar={false}
            onChangeCategoria={this.handleCategoriaChange}
            onChangeCorsi={this.handleCorsiChange}
            pdf={false}
            excel={false}
            mail={true}
            phone={false}
            rows={this.state.listaAttesa}
            // 	onDelete={async id => {
            // 		if (window.confirm("Sei sicuro di voler eliminare lo studente?") == false) return;

            // 		const cookies = new Cookies();
            // 		const username = cookies.get("username", { path: "/" });
            // 		const token = cookies.get("token", { path: "/" });
            // 		await DeleteStudente(username, token, id);
            // 		this.reload();
            // 	}}
          />

          <br />

          <h3 style={{ marginTop: 20, fontSize: 28 }}>Lista Invitati</h3>

          <Table
            headCells={headCells}
            searchCols={this.searchCols}
            assenze={false}
            calendar={false}
            onChangeCategoria={this.handleCategoriaChange}
            onChangeCorsi={this.handleCorsiChange}
            pdf={false}
            excel={false}
            mail={true}
            phone={false}
            rows={this.state.listaInvitati}
            // 	onDelete={async id => {
            // 		if (window.confirm("Sei sicuro di voler eliminare lo studente?") == false) return;

            // 		const cookies = new Cookies();
            // 		const username = cookies.get("username", { path: "/" });
            // 		const token = cookies.get("token", { path: "/" });
            // 		await DeleteStudente(username, token, id);
            // 		this.reload();
            // 	}}
          />

          <br />

          <h3 style={{ marginTop: 20, fontSize: 28 }}>
            Lista studenti ritirati
          </h3>

          <Table
            headCells={headCells}
            searchCols={this.searchCols}
            assenze={false}
            calendar={false}
            onChangeCategoria={this.handleCategoriaChange}
            onChangeCorsi={this.handleCorsiChange}
            pdf={false}
            excel={false}
            mail={true}
            phone={false}
            rows={this.state.listaRitirati}
          />

          <br />
          <FixButton
            title={"Salva"}
            callback={this.state.isLoading ? () => {} : this.lockedSaveEvento}
          />
          <br />

          <Modal
            isOpen={this.state.isModalOpen}
            onClose={this.closeModal}
            onConfirm={() => this.sendTo()}
            title="A chi è destinato l'invito?"
            message="Studenti"
            categorie={this.state.optionsCategoria}
            selectedCategoria={this.state.selectedCategoria}
            onChangeCategoria={this.handleCategoriaChange}
            onBlackListChange={this.handleBlackListChange}
            corsi={this.state.optionsCorsi}
            selectedCorsi={this.state.selectedCorsi}
            onChangeCorsi={this.handleCorsoChange}
            secondMessage="Ex studenti"
            exStudentiCategoria={this.state.exStudentiCategoria}
            selectedCategoriaExStudenti={this.state.selectedCategoriaExStudenti}
            onChangeCategoriaExStudenti={this.handleCategoriaChangeExStudenti}
          />

          <Modal
            isOpen={this.state.isEmailModalOpen}
            onClose={this.closeEmailModal}
            onConfirm={() => this.sendEmail()}
            title="A chi vuoi inviare l'email?"
            message="Studenti"
            categorie={this.state.optionsCategoria}
            selectedCategoria={this.state.selectedCategoriaEmail}
            onChangeCategoria={this.handleCategoriaChangeEmail}
            onBlackListChange={this.handleBlackListChangeEmail}
            corsi={this.state.optionsCorsi}
            selectedCorsi={this.state.selectedCorsiEmail}
            onChangeCorsi={this.handleCorsoChangeEmail}
            secondMessage="Ex studenti"
            exStudentiCategoria={this.state.exStudentiCategoria}
            selectedCategoriaExStudenti={
              this.state.selectedCategoriaExStudentiEmail
            }
            onChangeCategoriaExStudenti={
              this.handleCategoriaChangeExStudentiEmail
            }
          />

          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
            <FixButton
              title={"INVIA INVITO SU PRENOTAZIONE"}
              callback={() => {
                this.openEmailModal();
              }}
            />
          </div>

          <PageTitle
            button={"INVIA INVITI"}
            onClick={() => {
              this.openModal();
            }}
            secondButton={"INVIA PROMEMORIA"}
            onSecondClick={() => this.sendReminder()}
          />
        </LoadingOverlay>
      </>
    );
  }

  isValidUrl(urlString) {
    var urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // validate fragment locator
    return !!urlPattern.test(urlString);
  }

  // Converte il contenuto HTML in EditorState
  convertHtmlToEditorState(html) {
    if (!html) return EditorState.createEmpty();
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  }

  handleBlackListChange(e) {
    this.setState({ blacklist: !this.state.blacklist });
  }

  async sendTo() {
    if (
      !window.confirm(
        "Vuoi davvero inviare questo evento? L'azione è irreversibile"
      )
    ) {
      return;
    }

    this.setState({ isLoading: true });

    const cookies = new Cookies();
    let username = cookies.get("username", { path: "/" });
    let token = cookies.get("token", { path: "/" });
    let current = cookies.get("currentEvent", { path: "/" });

    const xStartDate = this.startDateRef.current.getDate();
    let date = xStartDate ? moment(xStartDate).format("DD/MM/yyyy") : "";

    let destinatariCategorie = [];
    let destinatariCorsi = [];
    let destinatariExStudenti = null;

    if (
      this.state.selectedCategoria &&
      this.state.selectedCategoria.length > 0
    ) {
      const categorieValues = this.state.selectedCategoria.map(
        (cat) => cat.value
      );
      if (categorieValues.includes("seleziona tutti")) {
        destinatariCategorie.push("all");
      } else {
        destinatariCategorie.push(...categorieValues);
      }
    }

    if (this.state.selectedCorsi && this.state.selectedCorsi.length > 0) {
      destinatariCorsi.push(
        ...this.state.selectedCorsi.map((corso) => corso.value)
      );
    }

    if (
      this.state.selectedCategoriaExStudenti &&
      this.state.selectedCategoriaExStudenti.length > 0
    ) {
      const exStudentiValues = this.state.selectedCategoriaExStudenti
        .filter((ex) => ex.value !== "NON INVITARE")
        .map((ex) => ex.value);

      if (exStudentiValues.includes("seleziona tutti")) {
        destinatariExStudenti = "all";
      } else if (exStudentiValues.length > 0) {
        destinatariExStudenti = exStudentiValues.join(";");
      }
    }

    if (
      destinatariCategorie.length === 0 &&
      destinatariCorsi.length === 0 &&
      !(destinatariExStudenti === "all" || destinatariExStudenti)
    ) {
      alert("Nessun destinatario selezionato.");
      this.setState({ isLoading: false });
      return;
    }

    await sendEvento(
      username,
      token,
      this.state.titolo.replace(/"/g, "'"),
      date,
      destinatariCategorie.join(";"),
      destinatariCorsi.join(";"),
      destinatariExStudenti,
      current,
      this.state.orario,
      this.state.blacklist,
      this.state.orarioFine,
      this.state.desc
    );

    this.setState({
      isLoading: false,
      selectedCategoria: [],
      selectedCorsi: [],
      selectedCategoriaExStudenti: [],
      blacklist: false,
      isModalOpen: false,
    });

    alert("Inviti inviati con successo!");
    await this.reload();
  }

  async sendReminder() {
    if (
      !window.confirm(
        "Vuoi davvero inviare il promemoria? L'azione è irreversibile"
      )
    ) {
      return;
    }

    this.setState({ isLoading: true });

    const cookies = new Cookies();
    let username = cookies.get("username", { path: "/" });
    let token = cookies.get("token", { path: "/" });
    let current = cookies.get("currentEvent", { path: "/" });

    const xStartDate = this.startDateRef.current.getDate();
    let date = xStartDate ? moment(xStartDate).format("DD/MM/yyyy") : "";

    await sendReminder(
      username,
      token,
      this.state.titolo.replace(/"/g, "'"),
      date,
      this.state.orario,
      current
    );

    this.setState({ isLoading: false });
    alert("Promemoria inviato con successo!");
    await this.reload();
  }

  async sendEmail() {
    if (
      !window.confirm(
        "Vuoi davvero inviare l'email di invito? L'azione è irreversibile"
      )
    ) {
      return;
    }

    this.setState({ isLoading: true });

    const cookies = new Cookies();
    let username = cookies.get("username", { path: "/" });
    let token = cookies.get("token", { path: "/" });
    let current = cookies.get("currentEvent", { path: "/" });

    const xStartDate = this.startDateRef.current.getDate();
    let date = xStartDate ? moment(xStartDate).format("DD/MM/yyyy") : "";

    let destinatariCategorie = [];
    let destinatariCorsi = [];
    let destinatariExStudenti = null;

    if (this.state.selectedCategoriaEmail) {
      this.state.selectedCategoriaEmail.forEach((categoria) => {
        if (categoria.value !== "seleziona tutti") {
          destinatariCategorie.push(categoria.value);
        } else {
          this.state.optionsCategoria.forEach((cat) => {
            if (cat.value !== "seleziona tutti") {
              destinatariCategorie.push(cat.value);
            }
          });
        }
      });
    }

    if (this.state.selectedCorsiEmail) {
      this.state.selectedCorsiEmail.forEach((corso) => {
        destinatariCorsi.push(corso.value);
      });
    }

    if (this.state.selectedCategoriaExStudentiEmail) {
      destinatariExStudenti = this.state.selectedCategoriaExStudentiEmail.value;
    }

    await sendEventEmail(
      username,
      token,
      this.state.titolo.replace(/"/g, "'"),
      date,
      destinatariCategorie,
      destinatariCorsi,
      destinatariExStudenti,
      current,
      this.state.orario,
      this.state.blacklistEmail,
      this.state.orarioFine,
      this.state.desc
    );

    this.setState({ isLoading: false, isEmailModalOpen: false });
    alert("Email inviate con successo!");
    await this.reload();
  }

  async save() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    if (!this.state.titolo.trim()) {
      alert("Inserire almeno un titolo per l'evento");
      return;
    }

    if (!this.state.desc.trim()) {
      alert("Inserire almeno una descrizione per l'evento");
      return;
    }

    if (this.state.link1 && !this.isValidUrl(this.state.link1)) {
      alert("Link 1 non sembra essere un indirizzo valido.");
      return;
    }

    if (this.state.link2 && !this.isValidUrl(this.state.link2)) {
      alert("Link 2 non sembra essere un indirizzo valido.");
      return;
    }

    if (!this.state.orario || !this.state.orarioFine) {
      alert("Inserire un orario di inizio e fine per l'evento");
      return;
    }

    if (
      (this.state.link1 && !this.state.titolo_l1.trim()) ||
      (this.state.link2 && !this.state.titolo_l2.trim())
    ) {
      if (
        !window.confirm(
          "Uno o più link non hanno un titolo impostato. Nell'applicazione i pulsanti verranno mostrati con testi di default (ad es: APRI LINK). Vuoi procedere comunque?"
        )
      ) {
        return;
      }
    }

    if (this.state.partecipanti <= 0) {
      alert("Il numero di partecipanti deve essere maggiore di 0");
      return;
    }

    const xStartDate = this.startDateRef.current.getDate();
    let date = xStartDate ? moment(xStartDate).format("DD/MM/yyyy") : "";

    // Verifica se c'è un nuovo allegato da caricare
    // this.state.attachment contiene il base64 solo se è stato scelto un nuovo file
    const hasNewAttachment =
      !!this.state.attachment && this.state.attachment.startsWith("data:");

    this.setState({
      isLoading: true,
      isUploading: hasNewAttachment,
      uploadProgress: 0,
    });

    let evento = {
      id: cookies.get("currentEvent", { path: "/" }),
      titolo: this.state.titolo,
      descrizione: this.state.desc,
      link1: this.state.link1,
      link2: this.state.link2,
      titolo_l1: this.state.titolo_l1,
      titolo_l2: this.state.titolo_l2,
      locandina: this.state.locandina,
      allegato: this.state.attachment,
      allegato_nome: this.state.attachmentFileName || "",
      data: date,
      partecipanti: this.state.partecipanti,
      orario: this.state.orario,
      orarioFine: this.state.orarioFine,
    };

    let ret = await editEvento(username, token, evento, (progress) => {
      this.setState({ uploadProgress: progress });
    });

    if (ret.result == "ok") {
      this.setState({ isLoading: false, isUploading: false });
      alert("Evento aggiornato con successo");
      this.reload();
    } else {
      this.setState({ isLoading: false, isUploading: false });
      alert(
        "Si è verificato un errore inatteso durante la modifica dell'evento. Per favore, riprova."
      );
    }
  }
}
